export class BillingSummaryBuilder {
  constructor() {
    this.billing = {};
  }

  setOrganizationName(name) {
    this.billing.organizationName = name;
    return this;
  }

  setTeams(value) {
    this.billing.teams = value;
    return this;
  }

  setProactiveSocial(value) {
    this.billing.proactiveSocial = value;
    return this;
  }

  setSocialModeration(value) {
    this.billing.socialModeration = value;
    return this;
  }

  setUnknown(value) {
    this.billing.unknown = value;
    return this;
  }

  build() {
    return this.billing;
  }
}
